/*
 * Copyright 2015-2020 reserved by jufeng.com.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
'use strict';

var LOG = require('logger').getLogger('product.list');

var $ = window.jQuery = require('base'), _super = require('../com.jufeng.product');
var lazyload = $.Deferred();
require.ensure('block.lazyload', function() {
    lazyload.resolve(require('block.lazyload'));
})

$('#product_list').on('loaded', function() {
    // 分页
    require.ensure('./com.jufeng.list.page.helper', function() {
	var pageHelper = require('./com.jufeng.list.page.helper');
	pageHelper.init();
    });

    //
    $('#priceMin, #priceMax').on('keyup change blur', function() {
	var $this = $(this);
	var value = $this.val();
	if (/[\D]/.test(value)) {
	    value = value.replace(/[\D]+/, '', 'g');
	}
	$this.val(value);
    });
})

$('#accordion').on('loaded', function() {
    var topCatId = $(this).data('top-cat');
    $('[data-left-top-cat]').each(function() {
	var $this = $(this);
	var myCatId = $this.data('left-top-cat')
	if (topCatId == myCatId) {
	    $this.removeClass('collapsed');
	    $('[data-left-top-sub-cat="' + myCatId + '"]').addClass('in');
	} else {
	    $this.addClass('collapsed');
	    $('[data-left-top-sub-cat="' + myCatId + '"]').removeClass('in');
	}
    });
});

lazyload.done(function(lazyload) {
    lazyload.call($('.j-div-brand-list,j-div-second-cat-list,j-div-third-cat-list'), function() {
	$('.nav_category_group_box .more').click(function() {
	    $(this).parent().find('.collapse').toggle();
	    $(this).toggleClass('active');
	    setHeight();
	}); 
    });
});

// 级别居中
function setHeight() {
    $('.nav_category_group_box .left').each(function() {
	$(this).removeAttr('style');
	$(this).css('height', $(this).parent().height());
    });
}
// ==================

require('../../css/bootstrap.css');
require('../../css/font/fonts.css');
require('../../css/cat_nav.css');
require('../../css/style2.css');
require('../../css/common.css');
require('../../css/header.css');
require('../../css/footer.css');
require('../../css/product/cubeportfolio.css');
require('../../css/product/list.less');
require('../../css/activity.less');
require('../../css/floor_right.css');



// WEBPACK FOOTER //
// ./src/main/javascript/product/list/com.jufeng.list.js